import { getLpuRequestInterface } from 'www/modules/Schedule/models'
import type { getLpuItemInterface } from 'www/modules/Schedule/models/item'
import type { getLpuStorageInterface } from 'www/modules/Schedule/models/storage'
import type {
  LpuRequestInterface,
  LpuSpecialityRequestItem,
} from 'www/modules/Schedule/models/request'

export type LpuSpecialtyOption = {
  id: number
  name: string
  translit: string
  staff_appointment_type?: string | null
}

type LpuItemData = ReturnType<typeof getLpuItemInterface> & {
  coverNode?: HTMLElement
  scheduleNode?: HTMLElement
  scheduleNodeHTML?: string
}

type LpuScheduleData = {
  items: Map<HTMLElement, LpuItemData>
  storage: ReturnType<typeof getLpuStorageInterface>
}

/**
 * @description
 * Собирает данные для запроса за расписанием для клиник
 *
 * @param opts.data - интерфейс 'getModuleDataInterface'
 * @param opts.specialtiesData - объект с данными в формате ответа 'specialtiesRequest'
 *
 * @returns объект в формате 'getLpuRequest'
 */

const getLpuRequestData = (opts: {
  data: LpuScheduleData
  specialtiesData: Record<number, LpuSpecialtyOption[]>
}): LpuRequestInterface => {
  const baseData = getLpuRequestInterface()

  const {
    data,
    specialtiesData,
  } = opts

  const {
    dateStart,
    timedelta,
    specialtyId,
    specialtyName,
    specialtyTranslit,
  } = data.storage

  const usedSpecialtyFilter = specialtyId && specialtyName && specialtyTranslit

  baseData.dt_start = dateStart
  baseData.town_timedelta = timedelta

  const lpuSpecialities = [...data.items].map(([scheduleContainer, itemData]): LpuSpecialityRequestItem | undefined => {
    const { hasSlots, isAppointmentOn, lpuId } = itemData
    const lpuSpecialtiesList = lpuId === null ? undefined : specialtiesData[lpuId]
    const hasEveryNeedData = hasSlots && isAppointmentOn && scheduleContainer && lpuSpecialtiesList

    if (!hasEveryNeedData || lpuId === null) {
      return undefined
    }

    if (usedSpecialtyFilter) {
      const lpuSelectedSpecialty = lpuSpecialtiesList
        .find(({ id, translit }) => specialtyId === id && specialtyTranslit === translit) || lpuSpecialtiesList[0] // Выбранная специальность по умолчанию (при загрузке страницы) || при смене специальности

      if (!lpuSelectedSpecialty) {
        return undefined
      }

      return {
        lpu_id: lpuId,
        name: lpuSelectedSpecialty.name,
        translit: lpuSelectedSpecialty.translit,
        speciality_id: lpuSelectedSpecialty.id,
      }
    }

    return {
      lpu_id: lpuId,
      name: lpuSpecialtiesList[0].name,
      translit: lpuSpecialtiesList[0].translit,
      speciality_id: lpuSpecialtiesList[0].id,
    }
  })

  return { ...baseData, lpus_specialities: lpuSpecialities.filter((i): i is LpuSpecialityRequestItem => Boolean(i)) }
}

export default getLpuRequestData
